<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShield_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M6.263 18.013Q8.525 21.124 12 22q3.476-.875 5.738-3.988T20 11.1V5l-8-3-8 3v6.1q0 3.8 2.263 6.913m9.34-9.807a.703.703 0 1 1 .995.996l-5.592 5.591a.704.704 0 0 1-.996 0L7.207 11.99a.703.703 0 1 1 .995-.996l2.306 2.307z"
        clip-rule="evenodd"
    />
</svg>
